module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('b-button', {
    attrs: {
      "to": {
        name: 'welcome-service-list',
        params: {
          save: true
        }
      },
      "size": "sm",
      "variant": "link"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.funcType))]), _vm._v(" 服务\n    ")], 1), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.onSubmit,
      "reset": _vm.onReset
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "名称",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "name",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "代号",
      "label-for": "code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "code",
      "type": "text",
      "disabled": _vm.update,
      "required": ""
    },
    model: {
      value: (_vm.data.code),
      callback: function($$v) {
        _vm.$set(_vm.data, "code", $$v)
      },
      expression: "data.code"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "排位",
      "label-for": "icon"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "sortId",
      "type": "number",
      "min": "1",
      "required": ""
    },
    model: {
      value: (_vm.data.sortId),
      callback: function($$v) {
        _vm.$set(_vm.data, "sortId", $$v)
      },
      expression: "data.sortId"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "分类",
      "label-for": "category"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "category",
      "options": _vm.categories,
      "text-field": "name",
      "value-field": "code",
      "required": ""
    },
    model: {
      value: (_vm.data.category),
      callback: function($$v) {
        _vm.$set(_vm.data, "category", $$v)
      },
      expression: "data.category"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "简介",
      "label-for": "desc"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.briefOptions
    },
    on: {
      "change": _vm.changeMode
    },
    model: {
      value: (_vm.data.ismd),
      callback: function($$v) {
        _vm.$set(_vm.data, "ismd", $$v)
      },
      expression: "data.ismd"
    }
  }), _vm._v(" "), (_vm.data.ismd) ? _c('Markdown', {
    ref: "descMd",
    attrs: {
      "id": "desc",
      "text": _vm.data.brief,
      "required": ""
    }
  }) : _c('div', [_c('b-form-file', {
    staticClass: "mt-3",
    attrs: {
      "placeholder": _vm.uploadPlaceholder,
      "browse-text": _vm.uploadBrowseText
    },
    on: {
      "change": _vm.getFileContent
    },
    model: {
      value: (_vm.briefFile),
      callback: function($$v) {
        _vm.briefFile = $$v
      },
      expression: "briefFile"
    }
  }), _vm._v(" "), (_vm.data.brief) ? _c('b-card', {
    attrs: {
      "title": "当前Html"
    }
  }, [_c('b-card-text', [_vm._v("\n              " + _vm._s(_vm.data.brief) + "\n            ")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "outline-primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" 提交")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "outline-danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  }), _vm._v(" 复位")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0e3047c5!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WelcomeSettings/ServiceForm.vue
// module id = 8Zgi
// module chunks = 4